import { formatDate, formatFullDate } from "../../lib/utils";
import type { StoryWithUIState } from "../../types";
import { StoryThumbnail } from "../StoryThumbnail";
import { Card } from "../ui/card";
import { SharedBadge } from "./SharedBadge";
import { StoryActionButtons } from "./StoryActionButtons";
import { StoryProgressBar } from "./StoryProgressBar";
import { StoryStatusBadge } from "./StoryStatusBadge";

interface StoryCardProps {
    story: StoryWithUIState;
    onStoryClick: (storyId: string) => void;
    onDelete: (story: { id: string; title?: string; topic: string }) => void;
}

export function StoryCard({ story, onStoryClick, onDelete }: StoryCardProps) {
    return (
        <Card
            className="p-4 cursor-pointer hover:bg-primary/5 transition-colors"
            onClick={() => onStoryClick(story.id)}
        >
            <div className="flex gap-4">
                <div className="flex-shrink-0 space-y-2">
                    <StoryThumbnail storyId={story.id} size="lg" />
                    {story.hasShare && (
                        <div className="flex justify-center">
                            <SharedBadge />
                        </div>
                    )}
                </div>
                <div className="flex-1 space-y-2">
                    <div className="space-y-1">
                        <h3 className="font-semibold">{story.title || story.topic}</h3>
                        {story.title && <p className="text-xs text-muted-foreground">Topic: {story.topic}</p>}
                    </div>
                    <div className="select-none">
                        <StoryProgressBar
                            currentStep={story.current_step}
                            totalSteps={story.total_steps}
                            status={story.status}
                            className="flex-1"
                        />
                    </div>
                    <div className="flex items-center justify-between select-none">
                        <StoryStatusBadge status={story.status} />
                        <span title={formatFullDate(story.updated_at)} className="text-xs text-muted-foreground">
                            {formatDate(story.updated_at)}
                        </span>
                    </div>
                    <div onClick={(e) => e.stopPropagation()}>
                        <StoryActionButtons
                            status={story.status}
                            onView={() => onStoryClick(story.id)}
                            onDelete={() => onDelete({ id: story.id, title: story.title, topic: story.topic })}
                            variant="mobile"
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
}
